import { render, staticRenderFns } from "./moduleNameConfig.vue?vue&type=template&id=189b3cf6&scoped=true&"
import script from "./moduleNameConfig.vue?vue&type=script&lang=ts&"
export * from "./moduleNameConfig.vue?vue&type=script&lang=ts&"
import style0 from "./moduleNameConfig.vue?vue&type=style&index=0&id=189b3cf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b3cf6",
  null
  
)

export default component.exports